import fireDrawerEvent from './fireDrawerEvent';
import getCurrentDrawerState from './getCurrentDrawerState';

const documentElement = document.documentElement;

const drawerClasses = ['cart-expanded', 'nav-expanded'];

const closeAllDrawers = () => {
  if (getCurrentDrawerState() !== 'open') return;
  
  drawerClasses.forEach((className) => {
    documentElement.classList.remove(className);
  });

  fireDrawerEvent.close();
};

export default closeAllDrawers;
